import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <a href="#service-ended-notice" className="bg-gradient-to-r from-primary via-purple-600 to-blue-600 bg-clip-text text-transparent hover:opacity-80 transition-opacity">
              キャッシュレス決済マップ
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-foreground/70 hover:text-foreground transition-colors">
              機能
            </a>
            <a href="#pricing" className="text-foreground/70 hover:text-foreground transition-colors">
              料金
            </a>
            <a href="#faq" className="text-foreground/70 hover:text-foreground transition-colors">
              FAQ
            </a>
            <Button disabled className="bg-gradient-to-r from-purple-600 to-blue-600">
              サービス終了
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-4">
            <a href="#features" className="block text-foreground/70 hover:text-foreground transition-colors">
              機能
            </a>
            <a href="#pricing" className="block text-foreground/70 hover:text-foreground transition-colors">
              料金
            </a>
            <a href="#faq" className="block text-foreground/70 hover:text-foreground transition-colors">
              FAQ
            </a>
            <Button disabled className="w-full bg-gradient-to-r from-purple-600 to-blue-600">
              サービス終了
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
}
